import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Grout from '../../components/Grout/Grout'

const Groutpage = () => {
    return (
        <div>
        <Navbar/>
        <Grout/>


        <Footer/>

        </div>
    )
}

export default Groutpage